// extracted by mini-css-extract-plugin
export var button = "Navigation-module--button--5b80d";
export var closeButton = "Navigation-module--closeButton--261d7";
export var col2 = "Navigation-module--col2--8b6a4";
export var content = "Navigation-module--content--b3a70";
export var curve = "Navigation-module--curve--5e300";
export var headline = "Navigation-module--headline--2c84f";
export var logo = "Navigation-module--logo--d2894";
export var mainRow = "Navigation-module--mainRow--5449f";
export var navigation = "Navigation-module--navigation--05bad";